import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import { responseContract } from '../../lib';

const _GetRevenuePerUnitRequestDtoSchema = z.object({
  from: z.string(),
  to: z.string(),
  /** Omit for the whole portfolio; pass one id to scope to a single facility. */
  facilitiesIds: z.array(z.number()).optional(),
});

const GetRevenuePerUnitResponseDtoSchema = z.object({
  amountUsd: z.number().nullable(),
  changePct: z.number().nullable(),
});

export type GetRevenuePerUnitRequestDto = z.infer<
  typeof _GetRevenuePerUnitRequestDtoSchema
>;

export type GetRevenuePerUnitResponseDto = z.infer<
  typeof GetRevenuePerUnitResponseDtoSchema
>;

/**
 * Financial tab (ST #137). Scoped through `facilitiesIds` rather than a path
 * param, so Portfolio and Single Mode hit the same expression and can never
 * disagree.
 *
 * Note this is NOT the same endpoint as the older single-facility
 * `facilities/:id/revenue-per-resident`, which returns a sparkline and is
 * computed by its own SQL.
 */
export const getRevenuePerResidentScoped = (
  params: GetRevenuePerUnitRequestDto,
  config?: AxiosRequestConfig<GetRevenuePerUnitRequestDto>
) =>
  api
    .get('facilities/revenue-per-resident', { params, ...config })
    .then(responseContract(GetRevenuePerUnitResponseDtoSchema));

export const getRevenuePerBedScoped = (
  params: GetRevenuePerUnitRequestDto,
  config?: AxiosRequestConfig<GetRevenuePerUnitRequestDto>
) =>
  api
    .get('facilities/revenue-per-bed', { params, ...config })
    .then(responseContract(GetRevenuePerUnitResponseDtoSchema));
